// @greenlight-spec: 48-user-passthrough.md#box
// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
/**
 * What a builder agent needs before calling Box through the proxy; the
 * profile's `agentInstructions`.
 */
export const BOX_AGENT_INSTRUCTIONS = "Acts as the signed-in user. Forward the inbound X-Greenlight-Actor-Token header on every proxied call (for example GET /2.0/folders/0/items); the proxy swaps it for that person's own Box token, so each call sees exactly the files and folders they can see. A call with no actor token is refused with 401 proxy.actor_token_required.\n" +
    "Never send an As-User header; the proxy strips it. 403 proxy.upstream_user_unmapped means Box has no single active, non-admin user whose login is that person's email: IT fixes the Box account, the app cannot.\n" +
    'GET /2.0/files/{id}/content answers 302 to a short-lived dl.boxcloud.com URL; follow it without a token and never log it. Uploads to upload.box.com do not go through this integration.\n' +
    'Scheduled or background work cannot use this integration, because there is no user to act as.';
/**
 * Box Platform App → Greenlight registration guide for the Client Credentials
 * Grant profile that acts as each signed-in user. Rendered in one register-form
 * accordion and flattened into `acquisitionInstructions`.
 */
export const BOX_CCG_USER_STEPS = [
    {
        title: 'Before you start',
        body: 'This Box app can act as any managed user in your enterprise, admins included. Treat its Client Secret as enterprise-wide access and keep its scopes minimal.\n' +
            'Greenlight never acts as a Box admin or co-admin through this app, because every token it mints carries the Manage users scope. Admins use apps from a non-admin Box account.',
    },
    {
        title: 'Create the app',
        body: 'In the Box Developer Console, choose Create Platform App → Custom App → Server Authentication (Client Credentials Grant).',
    },
    {
        title: 'Set the access level',
        body: 'On the Configuration tab, set App Access Level to App + Enterprise Access.',
    },
    {
        title: 'Choose scopes',
        body: 'Under Application Scopes, check Read all files and folders stored in Box, plus Write all files and folders only if apps need to change content.\n' +
            'Check Manage users. Greenlight needs it to find each person’s Box account by email.',
    },
    {
        title: 'Advanced features',
        body: 'Under Advanced Features, turn on Generate user access tokens. Leave Make API calls using the as-user header off.',
    },
    {
        title: 'Copy the Client ID and Secret',
        body: 'Save the changes, then copy the Client ID and Client Secret from OAuth 2.0 Credentials. Box asks for two-factor verification before it shows the secret.',
    },
    {
        title: 'Authorize in the Admin Console',
        body: 'A Box admin opens Admin Console → Platform → Platform Apps (older tenants: Apps → Custom Apps Manager), chooses Add, pastes the Client ID, and Authorizes.\n' +
            'Any later change to scopes or access level needs Reauthorize from the app’s menu there, or Box keeps refusing tokens.',
    },
    {
        title: 'Copy the Enterprise ID',
        body: 'On the app’s General Settings tab in the Developer Console, copy the Enterprise ID.',
    },
    {
        title: 'Register in Greenlight',
        body: 'Enter the Client ID and the Enterprise ID on this form and paste the Client Secret under Credentials.\n' +
            'Each person’s Box login must match the email they sign in to Greenlight with.',
    },
];
//# sourceMappingURL=box-ccg-user-guide.js.map